<template>

  <div class="personal-info-management pl-60 pr-60 pt-20">

    <a-row class="mb-20">
      <a-col :offset="1"><span class="fs-24  mb-20">个人信息</span>  <span class="f-c-red ml-10">标* 为必填项 </span></a-col>
    </a-row>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form1" :rules="loginRules1">
      <a-form-model-item label="用户类型">
        {{ +userInfo.positiontype ===1?'管理员':'员工' }}
      </a-form-model-item>
      <a-form-model-item label="所属企业">
        {{ userInfo.company }}
      </a-form-model-item>
      <a-form-model-item label="登录用户名">
        {{ userInfo.username }}
      </a-form-model-item>
      <a-form-model-item label="登录密码">
        ******  <a-button v-if="+userInfo.positiontype ===1" class="ml-10" @click="showPwd = true">修改密码</a-button><span v-else class="ml-10 f-c-red fs-12">说明：请联系管理员重置密码</span>
      </a-form-model-item>
      <a-form-model-item label="手机号">
        {{ userInfo.mobile }}<a-button v-if="+userInfo.positiontype ===1" class="ml-10" @click="showPhone = true">更换手机号</a-button>
      </a-form-model-item>
      <a-form-model-item prop="staffname" label="昵称/姓名">
        <a-input :maxLength="8" v-model="form1.staffname" />
      </a-form-model-item>
      <a-form-model-item prop="email" label="邮箱">
        <a-input v-model="form1.email" />
      </a-form-model-item>
      <a-form-model-item prop="qq" label="QQ">
        <a-input v-model="form1.qq" />
      </a-form-model-item>
    </a-form-model>
    <a-row class="mt-20 mb-20">
      <a-col :offset="4">  <a-button
        type="primary"
        :loading="formLoading"
        @click="postForm1"
      >
        保存
      </a-button></a-col>
    </a-row>
    <Changepwd v-if="userInfo.mobile" :phone="userInfo.mobile" :show.sync="showPwd" @success="initData" />
    <ChangePhone v-if="userInfo.mobile" :phone="userInfo.mobile" :show.sync="showPhone" @success="initData" />

  </div>
</template>
<script>

import validate from '@framework/utils/biz-validate'
import Changepwd from '@/components/changepwd'
import ChangePhone from '@/components/changePhone'

export default {
  components: {
    Changepwd, ChangePhone
  },

  data() {
    const validateEmail = (rule, value, callback) => {
      if (!validate.email.pattern.test(value)) {
        callback(new Error(validate.email.msg))
      } else {
        callback()
      }
    }
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      showPhone: false,
      loginRules1: {

        // mobile: [
        //   { required: true, trigger: 'change', validator: validateMobile }
        // ],
        staffname: [
          { required: true, trigger: 'change', message: '请填写昵称/姓名' }
        ],
        qq: [
          { required: true, trigger: 'change', message: '请填写QQ' }
        ],

        email: [
          { required: true, trigger: 'change', validator: validateEmail }
        ]

      },
      formLoading: false,
      form1: {
        'email': '',
        // 'mobile': '',
        'staffname': '',
        'qq': ''
      },
      userInfo: {
        'createtime': '',
        'departmentid': 0,
        'departmentname': '',
        'displayMobile': '',
        'email': '',
        'mobile': '',
        'name': '',
        'parentuserid': 0,
        'positiontype': '',
        'qq': '',
        'staffid': 0,
        'staffname': '',
        'status': 0,
        'userid': 0,
        'username': ''
      },
      showPwd: false
    }
  },

  async created() {
    this.initData()
  },
  methods: {
    async postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true
          const res = await this.$http(this.$api.staffEdit, {
            ...this.form1, staffid: this.userInfo.staffid
          })
          if (res) {
            this.$message.success('保存成功')
            this.formLoading = false
          }
        }
      })
    },
    async initData() {
      const info = await this.$http(this.$api.staffGet)
      Object.assign(this.userInfo, info)
      this.form1.staffname = this.userInfo.name
      this.form1.qq = this.userInfo.qq
      this.form1.email = this.userInfo.email
    }

  }
}
</script>
<style lang="scss">

</style>
